
export * from '../../frontend-js-recharts/__liferay__/exports/recharts.js';
